import Button from "components/Button/Button";
import Icon from "components/Icon/Icon";
import PreLoader from "components/PreLoader/PreLoader";
import { Content } from "containers/RightPanel/RightPanel.styles";
import { fadeIn } from "react-animations";
import styled, { css, keyframes } from "styled-components";

export const fadeInAnimation = css`
  animation: 0.5s ${keyframes`${fadeIn}`} !important;
`;

export const Container = styled.div`
  width: 100%;
`;

export const ContentContainer = styled(Content)`
  ${fadeInAnimation}
`;

export const Spinner = styled(PreLoader)`
  position: absolute;
  margin-top: 80px;
`;

export const FormWrapper = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: 22px;

    ${({ theme }) => theme.xs`
      margin-bottom: 10px;
    `}
  }
`;

export const ButtonsWrapper = styled.div`
  align-self: center;
  margin-top: auto;
  padding: 15px 0;

  button {
    margin: 5px;
  }
`;

export const SectionTitle = styled.h3`
  margin: 15px 0 10px;
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.textSecondary};
`;

export const AddAddressWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -12px;
  margin-bottom: 10px;
`;

export const PackageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
`;

export const PackageTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.textSecondary};
`;

export const PackageRemoveButton = styled(Button)`
  padding: 5px;
`;

export const PackageRemoveIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  background-color: ${({ theme }) => theme.red};
`;

export const AddPackageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -12px;
  margin-bottom: 10px;
`;

// One selectable row per returned rate — the same look DeliveryList uses.
export const QuoteCard = styled.div<{ $isSelected?: boolean; $isClickable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 15px;
  border: 1px solid ${({ theme }) => theme.formBorder};
  border-radius: 8px;
  background-color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.primaryPale : theme.rowBg};
  user-select: none;
  ${({ $isClickable }) => ($isClickable ? "cursor: pointer;" : "")}

  & + & {
    margin-top: 8px;
  }
`;

export const QuoteInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const QuoteService = styled.b`
  line-height: 20px;
`;

export const QuoteLine = styled.span`
  font-size: 12px;
  line-height: 17px;
  color: ${({ theme }) => theme.black50};
`;

export const QuotePrice = styled.span`
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
`;

export const Currency = styled.span`
  color: ${({ theme }) => theme.black50};
  font-weight: 400;
`;

export const SectionButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 15px 0 5px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 0;
  line-height: 20px;
`;

export const InfoRowLabel = styled.span`
  color: ${({ theme }) => theme.black50};
`;
